import React, { useState, useEffect } from "react";
import Variants from "../components/skeletons/DashboardSkeleton";
import SharedTable from "../components/shared/SharedTable";
import CustomizedSnackbars from "../components/shared/SuccessPopup";
import backgroundImage from "../assets/background2.png";
import Form from "../components/PopupForm";
import SharedPopupModal from "../components/shared/SharedPopupModal";
import { useNavigate } from "react-router-dom";

const columns = [
  {
    field: "name",
    headerName: "Stockist",
    width: 325,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "desc",
    headerName: "Description",
    width: 325,
    headerClassName:
      "text-lg text-bold font-sans font-bold bg-skin-table-header text-skin-inverted text-center",
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
];

const DashBoard = () => {
  const navigate = useNavigate();

  const userDetails = JSON.parse(localStorage.getItem("token"));
  const isReadOnly = ["RBM", "ABM", "REPRESENTATIVE"].includes(userDetails?.result?.role);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [formData, setFormData] = useState({
    _id: "",
    desc: "",
    name: "",
    age: "",
  });

  // const [data, setData] = useState(null);

  const [fetchSuccess, setFetchSuccess] = useState(false);
  const [fetchFailure, setFetchFailure] = useState(false);

  const [pageState, setpageState] = useState({
    data: null,
    page: 1,
    pageSize: 5,
    total: 1,
  });

  const fetchData = async () => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/stokists/list?page=${pageState.page}&limit=${pageState.pageSize}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/login");
      }
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const jsonData = await response.json();
      setpageState((prev) => ({
        ...prev,
        data: jsonData.data,
        total: jsonData.totalpages,
      }));
      // console.log(jsonData)
      // setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageState.page, pageState.pageSize]); // Empty dependency array means this effect runs once on component mount

  const handleFetchSuccess = () => {
    setFetchSuccess(true);
    // You can add additional logic here if needed
  };

  const handleFetchFailure = () => {
    setFetchFailure(true);
    // You can add additional logic here if needed
  };

  const componentStyle = {
    height: "100%",
    width: 650,
    // Add other styles as needed
  };

  // const ComponentProps = {
  //   handleFetchFailure,
  //   handleFetchSuccess
  // }

  const popupModalProps = {
    fetchData,
    handleFetchFailure,
    handleFetchSuccess,
    formData,
  };

  return (
    <div className="h-full w-full flex flex-col p-4 gap-3">
      {pageState.data ? (
        <div
          className=" bg-skin-wrap-fill p-5 pb-7 flex flex-col gap-4 rounded-2xl drop-shadow-2xl mt-3 bg-cover bg-center h-100vh"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <h1 className="text-4xl font-bold font-sans text-skin-base">
            STOCKIST
          </h1>
          <div className="flex justify-between items-center">
            {/* <div>search box with down menu</div> */}
            {/* <SharedDataAddButton Component={AddForm} popupModalProps = {popupModalProps}/> */}
          </div>
          <div>
            {/* <BasicModal open={open} handleClose={handleClose} formData={formData} fetchData = {fetchData} handleFetchSuccess={handleFetchSuccess} handleFetchFailure={handleFetchFailure}/> */}
            <SharedPopupModal
              open={open}
              handleClose={handleClose}
              ChildComponent={Form}
              popupModalProps={popupModalProps}
            />
            <div className=" flex max-sm:flex-col justify-between  items-center mx-3 ">
              <SharedTable
                handleOpen={handleOpen}
                setFormData={isReadOnly ? null : setFormData}
                pageState={pageState}
                setpageState={setpageState}
                columns={columns}
                componentStyle={componentStyle}
              />
            </div>
          </div>
        </div>
      ) : (
        <Variants />
      )}
      {fetchSuccess && (
        <CustomizedSnackbars
          severity="success"
          message="Operation Successfull !"
          open={fetchSuccess}
          handleClose={() => setFetchSuccess(false)}
        />
      )}

      {fetchFailure && (
        <CustomizedSnackbars
          severity="error"
          message="Operation Failed !"
          open={fetchFailure}
          handleClose={() => setFetchFailure(false)}
        />
      )}
    </div>
  );
};

export default DashBoard;
